<template>
    <div class="redis-wrap">
        <el-button class="leader-common-button" @click="refresh()"
            >刷新Redis</el-button
        >
    </div>
</template>
<script>
import * as api from "@/http/api.js";
export default {
    methods: {
        refresh() {
            api.refreshRedis().then(res => {
                if (res && res.error_code === "0") {
                    this.$message({
                        message: res.error_msg,
                        type: "success"
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss">
.redis-wrap {
    text-align: center;
    width: 100%;
    height: 100%;
    padding: px2Rem(40px);
}
</style>
